import React from 'react';
import styles from './scenario-studio.module.css';

interface StudioLoaderProps {
  label?: string;
  variant?: 'inline' | 'overlay' | 'bar';
}

export const StudioLoader: React.FC<StudioLoaderProps> = ({
  label = 'Chargement…',
  variant = 'inline',
}) => {
  if (variant === 'bar') {
    return (
      <div className={styles.loadingBar} role="status" aria-live="polite">
        <span className={styles.spinner} aria-hidden />
        <span>{label}</span>
      </div>
    );
  }

  if (variant === 'overlay') {
    return (
      <div className={styles.loadingOverlay} role="status" aria-live="polite">
        <div className={styles.loadingCard}>
          <span className={styles.spinnerLg} aria-hidden />
          <span>{label}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.loaderInline} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden />
      <span>{label}</span>
    </div>
  );
};
